import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateMaternityLeaveForm } from "../../../components/create-maternity-leave-form";
import { useAFLRequest } from "../../../hooks";

const dataFallback = {};

export const MaternityLeaveEdit = withProcedureWraper(() => {
  const { data = dataFallback, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin nghỉ thai sản" loading={isRequestFetching}>
      <CreateMaternityLeaveForm data={data} />
    </ProcedureLayout>
  );
});
